// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Translations
import {withTranslation} from "react-i18next";
// SVG
import {infoSvg, bigCloseSvg} from "assets";
// Application
import {BillingAPI} from "views/Order/infrastructure";
import {showNotify, updatePlan} from "vendor/application/disptach";
import {Dialog, DialogContent} from "@material-ui/core";
// Amplitude API
import {AmplitudeAPI} from "@api/Amplitude";

class OrderProfessionalTrial extends Component {

    constructor(props) {
        super(props);
    }

    setProfessionalTrial = async (e) => {
        e.preventDefault();
        const {access, plans, user, device_id} = this.props.data;

        var id = "";
        plans.forEach(plan => {
            if (plan?.name === "professional_trial") {
                id = plan.id;
            }
        });
        const body = {
            "plan": {
                "id": id,
                "name": "professional_trial"
            }
        };

        try {
            const obj = new BillingAPI(user.account_id, access, this.props, body);
            const res = await obj.set_professional_trial();

            new AmplitudeAPI({
                event_type: "From Free plan to Pro Trial",
                device_id: device_id,
                user_id: user.email
            }).eventLog();

            this.props.dispatch(updatePlan(res));

            var data = { from: "professional_trial", type: "change_plan", severity: "success" };
            this.props.dispatch(showNotify(data));
        } catch (err) {
        }
    };

    render() {
        const {t} = this.props;
        return (
            <Dialog onClose={this.props.onClose} className="dialog_info" open={true}>
                <DialogContent>
                    <div>
                        <h4>{t("frontend_info.professional_trial.trial_title")}</h4>
                        <div className={"dialog_close"} onClick={(e) => {this.props.onClose(e);}}>{bigCloseSvg()}</div>
                        {infoSvg()}
                        <p className="p2">{t("frontend_info.professional_trial.trial_description")}</p>
                        <button id={"notify_button_info"} className="btn btn-info" onClick={(e) => this.setProfessionalTrial(e)}>{t("inputs:button.accept")}</button>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(OrderProfessionalTrial);

export default withTranslation(["notifications", "inputs"])(connect_);